module.exports = __webpack_public_path__ + "img/FORMAFARMACEUTICACOMP.67709c30.png";